import jwt_decode from 'jwt-decode';

import { USER_ROLES } from '~/constants/user_roles';
import { JsonTokenDecoded } from '~/types/JsonTokenDecoded';

export const getMainRoleUser = (accessToken: string) => {
  const decoded: JsonTokenDecoded = jwt_decode(accessToken);

  // Prioritize: agency, brand
  const orderedRoleList = [
    USER_ROLES.agency,
    USER_ROLES.brand,
    USER_ROLES.brandUser,
  ];

  return (
    orderedRoleList.find(role => decoded.realm_access.roles.includes(role)) ||
    USER_ROLES.anonymous
  );
};
